export const NOME_TIPO_CONTRATO: Record<string, string> = {
  a_classificar: 'A classificar', manutencao: 'Manutenção', locacao: 'Locação de equipamentos', comodato: 'Comodato',
  monitoramento: 'Monitoramento', garantia_venda: 'Garantia de venda', garantia_servico: 'Garantia de serviço',
  locacao_software: 'Locação de software', locacao_avulsa: 'Locação avulsa',
};
export const NOME_STATUS_CONTRATO: Record<string, string> = { rascunho: 'Rascunho', ativo: 'Ativo', suspenso: 'Suspenso', encerrado: 'Encerrado' };
export const NOME_PRIORIDADE_SLA: Record<string, string> = {
  critica: 'Crítica — emergencial (acesso ou segurança comprometidos)', alta: 'Alta', media: 'Média', baixa: 'Baixa',
};
export const dataBr = (d: string | null) => (d ? d.split('-').reverse().join('/') : '—');
export const dinheiro = (v: string | null) => (v == null ? null : Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));

/** Prazo em minutos → texto. Em contagem útil, múltiplos da jornada viram "dias úteis". */
export function prazoTexto(min: number | null, contagem: string | null, jornada = 540) {
  if (min == null) return 'Sem prazo';
  if (contagem === 'util' && min % jornada === 0 && min >= jornada) return `${min / jornada} dia${min / jornada > 1 ? 's' : ''} útil${min / jornada > 1 ? 'eis' : ''}`;
  const h = min / 60;
  const base = Number.isInteger(h) ? `${h} h` : `${min} min`;
  return contagem === 'util' ? `${base} úteis` : `${base} corridas`;
}

export interface Padroes {
  jornada_comercial_min: number;
  comercial: { comercial_inicio: string; comercial_fim: string };
  categorias: { id: string; codigo: string; nome: string }[];
  tipos: Record<string, { janela: string; preventivas_mes: number | null; garantia_meses: number | null; exclusoes: string | null;
    sla: { prioridade: string; prazo_atendimento_min: number; contagem: string; fonte: string }[];
    sistemas: { categoria_id: string; codigo: string; observacao: string | null }[] }>;
}

export const SISTEMAS: Record<string, string> = {
  automacao: 'Automação de portões', cftv: 'CFTV', acesso: 'Controle de acesso', perimetro: 'Perímetro (cerca/alarme)', rede: 'Rede',
  comunicacao: 'Comunicação', energia: 'Energia', eletrica: 'Elétrica', ti: 'TI',
};
export const NOME_PECAS: Record<string, string> = {
  nao_inclui: 'Não inclui (orçamento à parte)', so_locados: 'Só dos equipamentos locados', inclui: 'Inclui peças', franquia: 'Franquia (limite)',
};
/** Frequência como opção única de tela: "v2" = 2× por mês; "m3" = a cada 3 meses. */
export const FREQUENCIAS: [string, string][] = [
  ['v1', '1× por mês'], ['v2', '2× por mês (quinzenal)'], ['v3', '3× por mês'], ['v4', '4× por mês (semanal)'],
  ['m2', 'A cada 2 meses'], ['m3', 'A cada 3 meses'], ['m4', 'A cada 4 meses'], ['m6', 'A cada 6 meses'], ['m12', 'Uma vez por ano'],
];
export const paraFreq = (vezes: number, cada: number) => (cada > 1 ? `m${cada}` : `v${vezes}`);
export const deFreq = (f: string) => (f.startsWith('m') ? { vezes_mes: 1, a_cada_meses: Number(f.slice(1)) } : { vezes_mes: Number(f.slice(1)), a_cada_meses: 1 });

export interface LinhaPlano {
  id?: string; nome: string; sistemas: string[]; local_ids: string[] | null; vezes_mes: number; a_cada_meses: number;
  mes_referencia?: string | null; duracao_min?: number | null; observacao?: string | null; ativo?: boolean; origem?: string; frequencia?: string;
}
export interface Visita {
  contrato_id: string; contrato: string; cliente_id: string; cliente: string; plano_id: string; plano: string; sistemas: string[];
  local_id: string; local: string; competencia: string; visita: number; de: number; data_sugerida: string; duracao_min: number | null;
  os_id: string | null; os_numero: string | null; os_status: string | null; agendada_para: string | null; pulada?: string;
}
export const NOME_STATUS_DOC: Record<string, string> = {
  na_fila: 'Na fila', lendo: 'Lendo…', lido: 'Lido — conferir', erro: 'Erro na leitura', aplicado: 'Aplicado', descartado: 'Descartado',
};
export const classeStatusDoc = (s: string) => (s === 'lido' ? 's-aviso' : s === 'aplicado' ? 's-ok' : s === 'erro' ? 's-nok' : 's-na');

// SLA na tela: valor + unidade (horas corridas, horas úteis, dias úteis) ↔ minutos + contagem
export type Unidade = 'h_corridas' | 'h_uteis' | 'd_uteis';
export interface LinhaSla { prioridade: string; valor: string; unidade: Unidade }

export const paraLinha = (prioridade: string, min: number | null, contagem: string | null, jornada: number): LinhaSla => {
  if (min == null) return { prioridade, valor: '', unidade: 'h_corridas' };
  if (contagem === 'util' && min % jornada === 0) return { prioridade, valor: String(min / jornada), unidade: 'd_uteis' };
  return { prioridade, valor: String(+(min / 60).toFixed(2)), unidade: contagem === 'util' ? 'h_uteis' : 'h_corridas' };
};
export const paraMinutos = (l: LinhaSla, jornada: number) => {
  const v = Number(l.valor.replace(',', '.'));
  if (!l.valor.trim() || !Number.isFinite(v) || v <= 0) return { prazo_atendimento_min: null, contagem: 'corrida' };
  return { prazo_atendimento_min: Math.round(l.unidade === 'd_uteis' ? v * jornada : v * 60), contagem: l.unidade === 'h_corridas' ? 'corrida' : 'util' };
};

